const VaccineEntryForm = ({
  investigations,
  vaccineReportData,
  setVaccineReportData,
}) => {
  return (
    <div>
      {investigations?.map((investigation, index) => {
        const inputType =
          investigation?.investigation_tests[0]?.value_type?.toLowerCase();
        const dropdownValue =
          investigation?.investigation_tests[0]?.dropdown_value;

        return (
          <div key={index} className="d-flex align-items-center fs-6 mt-3">
            <label
              htmlFor={`${investigation?.name?.toLowerCase()}`}
              className="w-25"
            >
              {investigation?.name}
            </label>
            {inputType === "dropdown" ? (
              <select
                name="dropdown"
                value={
                  vaccineReportData?.find(
                    (report) =>
                      report?.test_id ===
                      investigation?.investigation_tests[0]?.id
                  )?.result
                }
                className={`form-select w-75`}
                id={`${investigation?.name?.toLowerCase()}`}
                onChange={(event) => {
                  setVaccineReportData((previousReport) => {
                    const updatedReport = previousReport.map((report) => {
                      if (
                        report?.test_id ===
                        investigation?.investigation_tests[0]?.id
                      ) {
                        return {
                          ...report,
                          result: event.target.value,
                        };
                      }
                      return report;
                    });
                    return updatedReport;
                  });
                }}
              >
                <option value="">-</option>
                {dropdownValue?.split(",").map((v, index) => (
                  <option key={index} value={v}>
                    {v}
                  </option>
                ))}
              </select>
            ) : (
              <div className="w-75">
                <div className="input-group w-100">
                  <input
                    type="text"
                    id={`${investigation?.name?.toLowerCase()}`}
                    value={
                      vaccineReportData?.find(
                        (report) =>
                          report?.test_id ===
                          investigation?.investigation_tests[0]?.id
                      )?.result
                    }
                    className={`form-control w-100`}
                    onChange={(event) => {
                      setVaccineReportData((previousReport) => {
                        const updatedReport = previousReport.map((report) => {
                          if (
                            report?.test_id ===
                            investigation?.investigation_tests[0]?.id
                          ) {
                            return {
                              ...report,
                              result: event.target.value,
                            };
                          }
                          return report;
                        });
                        return updatedReport;
                      });
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default VaccineEntryForm;
